import { render, staticRenderFns } from "./queryResults.vue?vue&type=template&id=27fb542e&scoped=true"
import script from "./queryResults.vue?vue&type=script&lang=js"
export * from "./queryResults.vue?vue&type=script&lang=js"
import style0 from "./queryResults.vue?vue&type=style&index=0&id=27fb542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb542e",
  null
  
)

export default component.exports